import { ReactNode, CSSProperties } from 'react';
import classnames from 'classnames/bind';
import styles from './index.module.less';

const cx = classnames.bind(styles);

interface EditionBlockProps {
  children: ReactNode;
  style?: CSSProperties;
  className?: string;
  /* 版心 style  */
  mainStyle?: CSSProperties;
}
// 版心
export function EditionBlock(props: EditionBlockProps) {
  const { className, mainStyle, children, style } = props;

  return (
    <section className={cx('edition-block', className)} style={style}>
      <section className={cx('edition-block-main')} style={mainStyle}>
        {children}
      </section>
    </section>
  );
}
